export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'cg_access_token',
  REFRESH_TOKEN: 'cg_refresh_token',
  USER: 'cg_user',
  REMEMBER_EMAIL: 'cg_remember_email',
  /** All emails remembered via "Remember Me" (JSON array, most recent first) */
  REMEMBER_EMAILS: 'cg_remember_emails',
  /** Email → encoded PIN map when "Remember Me" is checked */
  REMEMBER_PINS: 'cg_remember_pins',
  /** Hash path to open after login (e.g. /tasks/<uuid>) */
  PENDING_DEEP_LINK: 'cg_pending_deep_link',
} as const;
